export default function Footer(props) {
  return (
    <footer className="py-3 my-4">
      <ul className="nav justify-content-center border-bottom pb-3 mb-3">
        {/*<li className="nav-item"><a href="#" className="nav-link px-2 text-muted">Home</a></li>*/}
      </ul>
      <p className="text-center text-muted">
        © {new Date().getFullYear()} <a href="https://palmax.com.pl" title="Palmax.com.pl" target="_blank" className="text-decoration-none text-muted">Palmax.com.pl</a>
      </p>
    </footer>
  )
}
